import Card from "components/card/Card";
import {
  getFotoById,
  consultarGratuidadeSenior,
  editaGratuidade,
  getAllStatusPagination,
  pesquisaCliente,
  getAllStatusGratuidade,
} from "config/apis/requests";
import React, { useEffect, useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import {
  Flex,
  Text,
  Image,
  useColorModeValue,
  Icon,
  Stack,
  Modal,
  ModalOverlay,
  Box,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  SimpleGrid,
  useDisclosure,
  Select,
  FormLabel,
  Button,
} from "@chakra-ui/react";
import LoadingSpinner from "components/loadingSpinner/LoadingSpinner";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbSeparator,
} from "@chakra-ui/react";

import {
  maskDataHistoricoSemHora,
  maskDataHistorico,
  IsEmpty,
  calcularIdade,
  maskCelular,
  maskCpfCnpj,
  isAbleToGiveGratuidade,
} from "config/functions";
import HistoricoGratuidade from "../../atendimento/profile/components/HistoricoGratuidade";
import {
  MdPersonSearch,
  MdSearch,
  MdOutlineEngineering,
  MdCancel,
  MdStore,
} from "react-icons/md";
import InputField from "components/fields/InputField";
import PopOverAlert from "components/popAlert/popAlert";
import { RiSeparator } from "react-icons/ri";

function SeniorPendenteAprovacao() {
  const [items, setItems] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [indexTransacao, setIndexTransacao] = useState(0);
  const [loading, setLoading] = useState(false);
  const [contTotal, setContTotal] = useState(0);
  const [contStatusPendente, setContStatusPendente] = useState(0);
  const [contStatusSolicitado, setContStatusSolicitado] = useState(0);
  const [contStatusAprovado, setContStatusAprovado] = useState(0);
  const [contStatusRejeitado, setContStatusRejeitado] = useState(0);
  const [contStatusCancelado, setContStatusCancelado] = useState(0);

  const { isOpen, onOpen, onClose } = useDisclosure();
  const { isOpen: isOpenModal2, onClose: onCloseModal2 } = useDisclosure();
  const [numeroDocumento, setNumeroDocumento] = useState("");
  const [loadingFoto, setLoadingFoto] = useState(false);
  const [statusSelect, setStatusSelect] = useState(2);
  const [idCliente, setIdCliente] = useState("");
  const [ordemSelect, setOrdemSelect] = useState("asc");
  const recoverLoggedUser = [JSON.parse(localStorage.getItem("user"))];

  const textColorPrimary = useColorModeValue("secondaryGray.900", "white");
  const [userSelected, setUserSelected] = useState({
    base64Imagem: "",
    dataNascimento: "",
    dataCadastro: "",
    codigo: 0,
    telefone: "",
    numeroDocumento: "",
    numeroDocumentoAlternativo: "",
    email: "",
    nome: "",
    dataCadastro4codigo: "",
  });
  const bg = useColorModeValue("white", "navy.700");
  const textColorSecondary = "secondaryGray.600";

  //----estilos----------------------------------------------
  const textColorAguardandoAnalise = useColorModeValue("#FF9900", "white");
  const textColorValida = useColorModeValue("#62BB51", "white");
  const textColorNConfere = useColorModeValue("#8756A1", "white");
  const textColorImagemInvalida = useColorModeValue("#F05D5E", "white");
  const textColorEmAnalise = useColorModeValue("#DDCD36", "white");
  const textColorUsoIndevido = useColorModeValue("#FF0000", "white");
  const textColorBiometriaConfirmada = useColorModeValue("#004DFF", "white");

  const textColor = useColorModeValue("navy.700", "white");
  const brandColor = useColorModeValue("brand.500", "brand.400");

  const ordemSelectMap = [
    { value: "desc", label: "decrescente" },
    { value: "asc", label: "crescente" },
  ];
  const [isOpen2, setIsOpen2] = useState(false);
  let dataLogin: any = [];
  const [titlePopOver, setTitlePopOver] = useState("Ops...");
  const [subtitlePopOver, setSubtitlePopOver] = useState("");
  const [statusPopOver, setStatusPopOver] = useState("warning");

  const showPopOver = (status: string, title: string, subtitle: string) => {
    handleOpenAlert(true);
    setStatusPopOver(status);
    setTitlePopOver(title);
    setSubtitlePopOver(subtitle);
  };
  const idTipoGratuidade = 2;

  const handleChangeMask = (event: { target: { value: any } }) => {
    const { value } = event.target;

    if (value.length < 15) {
      const valueRet = maskCpfCnpj(value);
      setNumeroDocumento(valueRet);
    }
  };

  const pesquisaIdUsuario = async () => {
    dataLogin = await pesquisaCliente({
      email: null,
      nome: null,
      numeroDocumento: numeroDocumento.replace(/[^\d]+/g, ""),
      tipoBusca: "TODOS",
      tipoPessoa: "F",
    });
    if (dataLogin.length > 0) {
      setIdCliente(dataLogin[0]?.codigo);
    } else {
      setIdCliente("");
    }
  };

  useEffect(() => {
    //PEDIR EP PARA BUSCAR STATUS GRATUIDADE
    const fechDataStatus = async () => {
      const allStatusGratuidade = await getAllStatusGratuidade();
      if (
        allStatusGratuidade !== 400 &&
        allStatusGratuidade !== 404 &&
        allStatusGratuidade !== 500
      ) {
        setContTotal(0);
        allStatusGratuidade.map((status: any) => {
          if (status?.id === 1) {
            setContStatusPendente(status?.cont);
            setContTotal((contTotal) => contTotal + status?.cont);
          }
          if (status?.id === 2) {
            setContStatusSolicitado(status?.cont);
            setContTotal((contTotal) => contTotal + status?.cont);
          }
          if (status?.id === 3) {
            setContStatusAprovado(status?.cont);
            setContTotal((contTotal) => contTotal + status?.cont);
          }
          if (status?.id === 4) {
            setContStatusRejeitado(status?.cont);
            setContTotal((contTotal) => contTotal + status?.cont);
          }
          if (status?.id === 5) {
            setContStatusCancelado(status?.cont);
            setContTotal((contTotal) => contTotal + status?.cont);
          }
        });
      }
    };
    fechDataStatus();

    window.scroll(0, 0);

    if (numeroDocumento) {
      pesquisaIdUsuario();
    }

    getAllStatusPagination(
      indexTransacao,
      20,
      ordemSelect,
      idTipoGratuidade,
      statusSelect,
      idCliente,
    ).then(async (resultado) => {
      if (resultado.length > 0) {
        items.push(...resultado);
        setIndexTransacao(resultado[resultado.length - 1].id);
      } else if (resultado.length < 10) {
        setHasMore(false);
      }
    });
  }, [loading]);

  const fetchMoreData = () => {
    if (hasMore) {
      getAllStatusPagination(
        indexTransacao,
        20,
        ordemSelect,
        idTipoGratuidade,
        statusSelect,
        dataLogin[0]?.codigo || "",
      ).then(async (resultado) => {
        if (resultado.length > 0) {
          setIndexTransacao(resultado[resultado.length - 1].id);

          setItems((prevItems) => [...prevItems, ...resultado]);
        } else if (resultado.length < 10) {
          setHasMore(false);
        }
      });
    }
  };

  const showModalAudit = async (item: any) => {
    setLoadingFoto(true);
    setUserSelected({
      base64Imagem: "",
      dataNascimento: "",
      dataCadastro: "",
      codigo: 0,
      telefone: "",
      numeroDocumento: "",
      numeroDocumentoAlternativo: "",
      email: "",
      nome: "",
      dataCadastro4codigo: "",
    });
    onOpen();

    try {
      await getFotoById(item?.cdCliente).then(async function (result: any) {
        setUserSelected(result);
      });
    } finally {
      setLoadingFoto(false);
    }
  };

  const pesquisaComFiltros = async () => {
    setItems([]);

    setUserSelected(null);

    if (numeroDocumento) {
      dataLogin = await pesquisaCliente({
        email: null,
        nome: null,
        numeroDocumento: numeroDocumento.replace(/[^\d]+/g, ""),
        tipoBusca: "TODOS",
        tipoPessoa: "F",
      });
      if (dataLogin.length > 0) {
        setIdCliente(dataLogin[0]?.codigo);
      } else {
        setIdCliente("");
      }
    }
    getAllStatusPagination(
      0,
      20,
      ordemSelect,
      idTipoGratuidade,
      statusSelect,
      dataLogin[0]?.codigo || "",
    ).then(async (resultado) => {
      if (resultado.length > 0) {
        setItems((prevItems) => [...prevItems, ...resultado]);
        setIndexTransacao(resultado[resultado.length - 1].id);

        setHasMore(true);
        if (resultado.length < 10) {
          setHasMore(false);
        }
      } else if (resultado.length < 10) {
        setHasMore(false);
      }
    });
  };

  const handleGetGratuidade = async (
    idGratuidade: any,
    idStatus: any,
    status: string,
    descricao: string,
    acao: string,
    loginAtendimento: any,
  ) => {
    if (acao === "put") {
      editaGratuidade({
        id: idGratuidade,
        descricao: descricao,
        tipoGratuidade: {
          id: idTipoGratuidade,
          descricao: "Sênior",
        },
        statusGratuidade: {
          id: idStatus,
          descricao: descricao,
        },
        loginAtendente: loginAtendimento,
      });
    }
  };

  const concederGratuidade = async (codigoCliente: any, acao: any) => {
    setLoading(true);
    const temGratuidadeSenior = await consultarGratuidadeSenior(codigoCliente);
    const gratuidadeMaisRecente = [
      temGratuidadeSenior.reduce((maisRecente: any, atual: any) => {
        return new Date(atual.dataInclusao) > new Date(maisRecente.dataInclusao)
          ? atual
          : maisRecente;
      }),
    ];

    if (codigoCliente && codigoCliente !== undefined) {
      const gratuidade = gratuidadeMaisRecente[0];

      if (
        !IsEmpty(gratuidade) &&
        gratuidade?.id !== undefined &&
        gratuidade !== false &&
        gratuidade?.statusGratuidade?.id !== 3 &&
        gratuidade?.statusGratuidade?.id !== 4 &&
        gratuidade?.statusGratuidade?.id !== 5
      ) {
        if (acao === 1) {
          handleGetGratuidade(
            gratuidadeMaisRecente[0]?.id,
            3,
            "Aprovado",
            "UI-ATENDIMENTO",
            "put",
            recoverLoggedUser[0]?.login,
          );
          showPopOver("success", "Gratuidade", "Concedida!");
          pesquisaComFiltros();
          onClose();
        } else if (acao === 2) {
          handleGetGratuidade(
            gratuidadeMaisRecente[0]?.id,
            1,
            "Pendente",
            "UI-ATENDIMENTO",
            "put",
            recoverLoggedUser[0]?.login,
          );
          showPopOver("success", "Gratuidade", "Pendente!");
        } else if (acao === 3) {
          handleGetGratuidade(
            gratuidadeMaisRecente[0]?.id,
            4,
            "Rejeitado",
            "UI-ATENDIMENTO",
            "put",
            recoverLoggedUser[0]?.login,
          );
          showPopOver("success", "Gratuidade", "Rejeitada!");
        }
        pesquisaComFiltros();
        onClose();
      } else {
        if (
          gratuidadeMaisRecente[0]?.statusGratuidade.id === 3 ||
          gratuidadeMaisRecente[0]?.statusGratuidade.id === 4 ||
          gratuidadeMaisRecente[0]?.statusGratuidade.id === 5
        ) {
          showPopOver(
            "warning",
            "Gratuidade",
            "Já atualizada com status: " +
              gratuidadeMaisRecente[0]?.statusGratuidade?.descricao,
          );
          pesquisaComFiltros();
          onClose();
        } else {
          showPopOver("error", "Erro gratuidade", "Erro ao buscar gratuidade!");
          pesquisaComFiltros();
          onClose();
        }
      }
    }

    setLoading(false);
  };

  const descricaoStatusBiometria = (status: any, descricao: any) => {
    switch (status) {
      case 1:
        return (
          <Text
            color={textColorAguardandoAnalise}
            fontSize="sm"
            fontWeight="700"
          >
            {descricao}
          </Text>
        );
      case 2:
        return (
          <Text color={textColorValida} fontSize="sm" fontWeight="700">
            {descricao}
          </Text>
        );
      case 3:
        return (
          <Text color={textColorNConfere} fontSize="sm" fontWeight="700">
            {descricao}
          </Text>
        );
      case 4:
        return (
          <Text color={textColorImagemInvalida} fontSize="sm" fontWeight="700">
            {descricao}
          </Text>
        );
      case 5:
        return (
          <Text color={textColorEmAnalise} fontSize="sm" fontWeight="700">
            {descricao}
          </Text>
        );
      case 6:
        return (
          <Text color={textColorUsoIndevido} fontSize="sm" fontWeight="700">
            {descricao}
          </Text>
        );
      case 7:
        return (
          <Text
            color={textColorBiometriaConfirmada}
            fontSize="sm"
            fontWeight="700"
          >
            {descricao}
          </Text>
        );
    }
  };
  const handleOpenAlert = (
    status: boolean | ((prevState: boolean) => boolean),
  ) => {
    setIsOpen2(status);
  };
  return (
    <>
      <PopOverAlert
        handleOpenAlert={handleOpenAlert}
        isOpen={isOpen2}
        status={statusPopOver}
        title={titlePopOver}
        subtitle={subtitlePopOver}
      />
      <Card mt={"120px"} mb={"20px"}>
        <FormLabel
          ms="10px"
          htmlFor="Status"
          fontSize="larger"
          color={textColorPrimary}
          fontWeight="bold"
          _hover={{ cursor: "pointer" }}
        >
          Gratuidades
        </FormLabel>
        <Flex
          gridArea={{ base: "2 / 1 / 3 / 3", "2xl": "1 / 2 / 2 / 3" }}
          ml={"15px"}
        >
          <Card
            bgColor={"green.200"}
            width={"25"}
            alignItems={"center"}
            textAlign={"center"}
          >
            <Text fontWeight="bold" fontSize={"2xl"}>
              {" "}
              {contStatusAprovado}
            </Text>
            <Text>Aprovadas</Text>
            <Text fontWeight="bold">
              {contStatusAprovado && contTotal
                ? ((contStatusAprovado / contTotal) * 100).toFixed()
                : 0}
              %
            </Text>
          </Card>
          <Card
            bgColor={"blue.200"}
            width={"25"}
            alignItems={"center"}
            ml={"15px"}
            textAlign={"center"}
          >
            <Text fontWeight="bold" fontSize={"2xl"}>
              {" "}
              {contStatusSolicitado}
            </Text>
            <Text>Solicitadas </Text>
            <Text fontWeight="bold">
              {contStatusSolicitado && contTotal
                ? ((contStatusSolicitado / contTotal) * 100).toFixed()
                : 0}
              %
            </Text>
          </Card>
          <Card
            bgColor={"orange.200"}
            width={"25"}
            alignItems={"center"}
            ml={"15px"}
            textAlign={"center"}
          >
            <Text fontWeight="bold" fontSize={"2xl"}>
              {" "}
              {contStatusPendente}
            </Text>
            <Text>Pendentes</Text>
            <Text fontWeight="bold">
              {contStatusPendente && contTotal
                ? ((contStatusPendente / contTotal) * 100).toFixed()
                : 0}
              %
            </Text>
          </Card>
          <Card
            bgColor={"red.200"}
            width={"25"}
            alignItems={"center"}
            ml={"15px"}
            textAlign={"center"}
          >
            <Text fontWeight="bold" fontSize={"2xl"}>
              {" "}
              {contStatusRejeitado}
            </Text>
            <Text>Rejeitadas</Text>
            <Text fontWeight="bold">
              {contStatusRejeitado && contTotal
                ? ((contStatusRejeitado / contTotal) * 100).toFixed()
                : 0}
              %
            </Text>
          </Card>
          <Card
            bgColor={"red.600"}
            width={"25"}
            alignItems={"center"}
            ml={"15px"}
            textAlign={"center"}
          >
            <Text fontWeight="bold" fontSize={"2xl"}>
              {" "}
              {contStatusCancelado}
            </Text>
            <Text>Canceladas</Text>
            <Text fontWeight="bold">
              {contStatusCancelado && contTotal
                ? ((contStatusCancelado / contTotal) * 100).toFixed()
                : 0}
              %
            </Text>
          </Card>
          <Card
            bgColor={"grey"}
            width={"60"}
            alignItems={"center"}
            justifyContent={"center"}
            ml={"15px"}
            textAlign={"center"}
          >
            <Text fontWeight="bold" fontSize={"2xl"}>
              {" "}
              {contTotal}
            </Text>
            <Text fontWeight="bold">Total</Text>
          </Card>
        </Flex>
      </Card>
      <Card mb={"15px"} width={"100%"}>
        <FormLabel
          ms="10px"
          htmlFor="Status"
          fontSize="larger"
          color={textColorPrimary}
          fontWeight="bold"
          _hover={{ cursor: "pointer" }}
        >
          Filtros de busca
        </FormLabel>
        <Flex
          direction={"row"}
          justifyContent="space-between"
          alignContent={"flex-start"}
        >
          <Flex direction={"column"} mr={"20px"}>
            <FormLabel
              ms="10px"
              htmlFor="Status"
              fontSize="sm"
              color={textColorPrimary}
              fontWeight="bold"
              _hover={{ cursor: "pointer" }}
            >
              Status transação
            </FormLabel>
            <Select
              w={"140px"}
              isRequired={true}
              id="status"
              name="status"
              h="44px"
              fontSize="sm"
              fontWeight="500"
              borderRadius="16px"
              value={statusSelect}
              defaultValue={0}
              onChange={(e: {
                target: { value: React.SetStateAction<string> };
              }) => setStatusSelect(Number(e.target.value))}
            >
              <option value="2" selected>
                Solicitadas
              </option>
              <option value="1">Pendente</option>
              <option value="3">Aprovado</option>
              <option value="4">Rejeitado</option>
              <option value="5">Cancelado</option>
            </Select>
          </Flex>
          <Flex direction={"column"} ml={"20px"}>
            <FormLabel
              ms="10px"
              htmlFor="Status"
              fontSize="sm"
              color={textColorPrimary}
              fontWeight="bold"
              _hover={{ cursor: "pointer" }}
            >
              Ordem
            </FormLabel>
            <Select
              w={"180px"}
              isRequired={true}
              id="status"
              name="status"
              h="44px"
              fontSize="sm"
              fontWeight="500"
              borderRadius="16px"
              value={ordemSelect}
              defaultValue={"desc"}
              onChange={(e: {
                target: { value: React.SetStateAction<string> };
              }) => setOrdemSelect(e.target.value)}
            >
              <option value="" selected>
                Selecione a ordem
              </option>
              {ordemSelectMap.map((option, index) => (
                <option key={index} value={option.value}>
                  {option.label}
                </option>
              ))}
            </Select>
          </Flex>
          <Flex direction={"column"} ml={"40px"}>
            <InputField
              isRequired={true}
              ml={"125px"}
              w="200px"
              h="50px"
              id="numeroDocumento"
              label="CPF"
              value={numeroDocumento}
              onChange={handleChangeMask}
              //onKeyDown={handleKeyDown}
            />
          </Flex>
          <Flex
            direction={"column"}
            justifyContent="flex-end"
            alignItems={"flex-end"}
            mr={"20px"}
            w="90%"
          >
            <Button
              fontSize="sm"
              p={"20px"}
              w={"123px"}
              borderRadius="16px"
              leftIcon={<MdSearch size="20px" />}
              onClick={pesquisaComFiltros}
              colorScheme="blue"
              isLoading={loading}
            >
              Pesquisar
            </Button>
          </Flex>
        </Flex>
      </Card>

      <Flex direction={"column"} justifyContent="initial" mt={"10px"}>
        <InfiniteScroll
          dataLength={items.length}
          next={fetchMoreData}
          hasMore={true}
          loader={
            <Flex
              justify="center"
              px="10px"
              pt="5px"
              mb="25px"
              mt="20px"
              alignItems={"center"}
            >
              {!hasMore ? (
                <Text color={textColor} fontSize="sm" fontWeight="400">
                  Não há dados a serem carregados
                </Text>
              ) : (
                <LoadingSpinner size="45px" />
              )}
            </Flex>
          }
        >
          {items.length > 0 &&
            items.map((item: any, index) => (
              <Card mt={"15px"} mb={"15px"} width={"99%"} key={index}>
                <Flex
                  direction={"row"}
                  alignItems={"center"}
                  width={"full"}
                  justifyContent={"space-between"}
                >
                  <Flex align="center" direction={"column"} w={"220px"}>
                    <Text color={textColor} fontSize="md" fontWeight="700">
                      Data inclusão:
                    </Text>
                    <Text
                      color={textColor}
                      fontSize="sm"
                      fontWeight="500"
                      align={"center"}
                    >
                      {maskDataHistorico(item?.dataInclusao)}{" "}
                    </Text>
                  </Flex>
                  <Flex align="center" direction={"column"} w={"220px"}>
                    <Text color={textColor} fontSize="md" fontWeight="700">
                      Status transação
                    </Text>
                    <Text
                      color={textColor}
                      fontSize="sm"
                      fontWeight="500"
                      align={"center"}
                    >
                      {descricaoStatusBiometria(
                        item?.statusGratuidade.id,
                        item?.statusGratuidade.descricao,
                      )}
                    </Text>
                  </Flex>

                  <Flex alignItems={"flex-end"} direction={"column"}>
                    <Icon
                      as={MdPersonSearch}
                      cursor="pointer"
                      width="30px"
                      height="30px"
                      color={brandColor}
                      onClick={() => showModalAudit(item)}
                    />
                  </Flex>
                </Flex>
              </Card>
            ))}
        </InfiniteScroll>
      </Flex>

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent maxW="-webkit-max-content" alignSelf={"center"}>
          <ModalHeader></ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Stack
              direction="row"
              mb="20px"
              justifyContent="space-evenly"
              cursor="pointer"
            >
              <Stack
                direction="column"
                style={{ alignItems: "center" }}
                width={"-moz-fit-content"}
              >
                <Text fontWeight="bold">Imagem de cadastro</Text>
                {loadingFoto ? (
                  <Flex justify="center" px="10px" pt="5px" mb="25px">
                    <LoadingSpinner size="40px" />
                  </Flex>
                ) : (
                  <Card
                    bg="orange.500"
                    style={{ padding: "5px", marginBottom: "2px" }}
                  >
                    {userSelected?.base64Imagem ? (
                      <Image
                        borderRadius="20px"
                        objectFit="cover"
                        boxSize="350px"
                        src={
                          "data:image/png;base64, " + userSelected?.base64Imagem
                        }
                        alt={"Imagem Cadastro"}
                      />
                    ) : (
                      <Text
                        fontWeight="bold"
                        mt={"125px"}
                        mb={"125px"}
                        ml={"75px"}
                        mr={"75px"}
                      >
                        Sem imagem de cadastro
                      </Text>
                    )}
                  </Card>
                )}
              </Stack>
              <Flex
                direction="column"
                mb="30px"
                ml={"15px"}
                width={"-moz-min-content"}
              >
                <Text
                  color={textColorPrimary}
                  fontWeight="bold"
                  fontSize="20px"
                  mt="10px"
                  mb="4px"
                >
                  Dados da transação
                </Text>

                <SimpleGrid columns={4} gap="10px">
                  <Box>
                    <Card bg={bg}>
                      <Text
                        fontWeight="500"
                        color={textColorSecondary}
                        fontSize="sm"
                      >
                        Data nascimento
                      </Text>
                      <Text
                        color={textColorPrimary}
                        fontWeight="700"
                        fontSize="sm"
                      >
                        {userSelected?.dataNascimento &&
                          maskDataHistoricoSemHora(
                            userSelected?.dataNascimento,
                          )}{" "}
                      </Text>
                      <Text
                        fontWeight="500"
                        color={textColorSecondary}
                        fontSize="sm"
                        mt={"15px"}
                      >
                        Idade
                      </Text>
                      <Text
                        color={
                          userSelected?.dataNascimento &&
                          calcularIdade(userSelected?.dataNascimento) < 65
                            ? "red"
                            : textColorPrimary
                        }
                        fontWeight="700"
                        fontSize="sm"
                      >
                        {userSelected?.dataNascimento
                          ? calcularIdade(userSelected?.dataNascimento)
                          : null}{" "}
                        anos
                      </Text>
                    </Card>
                  </Box>
                  <Box>
                    <Card bg={bg}>
                      <Text
                        fontWeight="500"
                        color={textColorSecondary}
                        fontSize="sm"
                      >
                        Número Documento
                      </Text>
                      <Text
                        color={textColorPrimary}
                        fontWeight="700"
                        fontSize="sm"
                      >
                        {userSelected?.numeroDocumento ??
                          userSelected?.numeroDocumentoAlternativo}
                      </Text>
                      <Text
                        fontWeight="500"
                        color={textColorSecondary}
                        fontSize="sm"
                        mt={"15px"}
                      >
                        Nome
                      </Text>
                      <Text
                        color={textColorPrimary}
                        fontWeight="700"
                        fontSize="sm"
                      >
                        {userSelected?.nome ? userSelected?.nome : "Sem dados."}
                      </Text>
                    </Card>
                  </Box>
                  <Box>
                    <Card bg={bg}>
                      <Text
                        fontWeight="500"
                        color={textColorSecondary}
                        fontSize="sm"
                      >
                        Email
                      </Text>
                      <Text
                        color={textColorPrimary}
                        fontWeight="700"
                        fontSize="sm"
                      >
                        {userSelected?.email
                          ? userSelected?.email
                          : "Sem email."}
                      </Text>
                      <Text
                        fontWeight="500"
                        color={textColorSecondary}
                        fontSize="sm"
                        mt={"15px"}
                      >
                        Telefone
                      </Text>
                      <Text
                        color={textColorPrimary}
                        fontWeight="700"
                        fontSize="sm"
                      >
                        {userSelected?.telefone
                          ? maskCelular(userSelected?.telefone)
                          : "Sem telefone."}
                      </Text>
                    </Card>
                  </Box>
                  <Box>
                    <Card bg={bg}>
                      <Text
                        fontWeight="500"
                        color={textColorSecondary}
                        fontSize="sm"
                      >
                        Data Cadastro
                      </Text>
                      <Text
                        color={textColorPrimary}
                        fontWeight="700"
                        fontSize="sm"
                      >
                        {userSelected?.dataCadastro
                          ? maskDataHistoricoSemHora(userSelected?.dataCadastro)
                          : null}
                      </Text>
                    </Card>
                  </Box>
                </SimpleGrid>
                {/* <Flex
                  w="100%"
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  p={4}
                >
                  {userSelected?.codigo !== 0 ? (
                    <>
                      <HistoricoGratuidade
                        dataUser={userSelected}
                        historicoGratuidadeEstudanteCartao={
                          historicoGratuidadeEstudanteCartao
                        }
                        historicoGratuidadeSeniorCartao={
                          historicoGratuidadeSeniorCartao
                        }
                        historicoGratuidadePcdCartao={
                          historicoGratuidadePcdCartao
                        }
                      />
                    </>
                  ) : (
                    <Text
                      color={textColorPrimary}
                      fontWeight="700"
                      fontSize="sm"
                    >
                      Sem dados de pesquisa.{" "}
                    </Text>
                  )}
                </Flex> */}
                <Flex
                  w="100%"
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  p={4}
                >
                  <Button
                    variant="solid"
                    colorScheme="orange"
                    fontSize="sm"
                    width={"200px"}
                    borderRadius="16px"
                    isLoading={loading}
                    disabled={
                      statusSelect === 5 ||
                      statusSelect === 4 ||
                      statusSelect === 3
                        ? true
                        : false
                    }
                    loadingText="Aguarde..."
                    onClick={() => concederGratuidade(userSelected?.codigo, 2)}
                    leftIcon={<MdStore size="20px" />}
                    p="25px"
                  >
                    Cadastro pendente{" "}
                  </Button>
                  <Button
                    variant="solid"
                    colorScheme="red"
                    fontSize="sm"
                    width={"200px"}
                    disabled={
                      statusSelect === 5 ||
                      statusSelect === 4 ||
                      statusSelect === 3
                        ? true
                        : false
                    }
                    borderRadius="16px"
                    isLoading={loading}
                    loadingText="Aguarde..."
                    onClick={() => concederGratuidade(userSelected?.codigo, 3)}
                    leftIcon={<MdCancel size="20px" />}
                    p="25px"
                  >
                    Rejeitar
                  </Button>
                  <Button
                    variant="solid"
                    colorScheme="green"
                    fontSize="sm"
                    width={"220px"}
                    disabled={
                      (userSelected?.dataNascimento
                        ? calcularIdade(userSelected?.dataNascimento) < 65 ||
                          statusSelect === 5 ||
                          statusSelect === 4 ||
                          statusSelect === 3 ||
                          loading
                          ? true
                          : false
                        : false) || !isAbleToGiveGratuidade()
                    }
                    borderRadius="16px"
                    isLoading={loading}
                    loadingText="Aguarde..."
                    onClick={() => concederGratuidade(userSelected?.codigo, 1)}
                    leftIcon={<MdOutlineEngineering size="20px" />}
                    p="25px"
                  >
                    Conceder gratuidade
                  </Button>
                </Flex>
              </Flex>
            </Stack>
          </ModalBody>
        </ModalContent>
      </Modal>
      <Modal isOpen={isOpenModal2} onClose={onCloseModal2}>
        <ModalOverlay />
        <ModalContent bg="transparent" boxShadow="unset">
          <ModalBody
            p="0px"
            boxShadow="unset"
            alignContent={"center"}
            alignItems={"center"}
            alignSelf={"center"}
          >
            <Card
              bgColor={"blackAlpha.400"}
              style={{
                padding: "105px",
                marginBottom: "2px",
                width: "100%",
                height: "100%",
              }}
            >
              <Flex
                position="relative"
                left="50%"
                transform="translate(-50%,0px)"
                zIndex="100"
                w="100%"
              >
                <Flex
                  align="center"
                  direction="row"
                  w="100%"
                  h={"100%"}
                  mt={"-40px"}
                >
                  <Flex align="center" direction="column" w="100%">
                    <Card
                      bg="green.300"
                      style={{
                        padding: "5px",
                        marginBottom: "2px",
                        width: "400px",
                        height: "100%",
                      }}
                    >
                      <Image
                        borderRadius="20px"
                        objectFit="contain"
                        h={"10%"}
                        // boxSize="300px"
                        src={"data:image/png;base64, " + ""}
                        alt={"Imagem Cadastro"}
                      />
                    </Card>
                    <Text
                      justifyContent="space-between"
                      align="center"
                      fontSize={{ sm: "15px", lg: "17px" }}
                      width="200px"
                      fontWeight={"bold"}
                      bgColor={"green.300"}
                      borderRadius="20px"
                      color={"white"}
                    >
                      Imagem biométrica
                    </Text>
                  </Flex>
                  <Flex align="center" direction="column" ml="15px" w="100%">
                    <Card
                      bg="red.300"
                      style={{
                        padding: "5px",
                        marginBottom: "2px",
                        width: "534px",
                        height: "100%",
                      }}
                    >
                      <Image
                        borderRadius="20px"
                        src={
                          "data:image/png;base64, " + userSelected?.base64Imagem
                        }
                        alt={"Imagem Cadastro"}
                      />
                    </Card>
                    <Text
                      justifyContent="space-between"
                      align="center"
                      fontSize={{ sm: "15px", lg: "17px" }}
                      width="60%"
                      fontWeight={"bold"}
                      bgColor={"red.300"}
                      borderRadius="20px"
                      color={"white"}
                    >
                      Imagem da transação
                    </Text>
                  </Flex>
                  <ModalCloseButton color="white" zIndex="99" />
                </Flex>
              </Flex>
            </Card>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
}

export default SeniorPendenteAprovacao;
